import { InfoCircleOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import { Flex, Tooltip, theme } from 'antd';
import type React from 'react';
import { LgBadge } from '../../components/LgBadge';
import { Price } from '../../components/Price.tsx';
import { BillingType } from '../../graphql/generated/graphql.ts';
import type { BillingInfo } from '../../hooks/store/useAppStore.ts';
import { translateBillingType } from '../../utils/enumHelpers';

export const BillingInfoComponent: React.FC<{ billingInfo: BillingInfo; showPrice?: boolean }> = ({ billingInfo, showPrice = true }) => {
  const { token } = theme.useToken();

  const spanStyle = css`
    line-height: 22px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `;

  const flexStyle = css`
    overflow: hidden;
  `;

  const errorText = css`
    color: ${token.colorError};
    font-weight: 500;
    text-transform: uppercase;
  `;

  switch (billingInfo.billingType) {
    case BillingType.SPECIAL_RATE:
      return (
        <span className={spanStyle}>
          {billingInfo.text} {showPrice && <Price value={billingInfo.price} />}
        </span>
      );
    case BillingType.INSURANCE:
      return (
        <span className={spanStyle}>
          {billingInfo.text} {showPrice && <Price value={billingInfo.price} />}
        </span>
      );
    case BillingType.LG_INSURANCE:
      return (
        <Flex gap={token.marginXXS} align="center" className={flexStyle}>
          <LgBadge />
          <span className={spanStyle}>
            {billingInfo.text} {showPrice && <Price value={billingInfo.price} />}
          </span>
        </Flex>
      );
    case BillingType.DIAGNOSE:
      return (
        <Tooltip title={billingInfo.text}>
          <Flex gap={token.marginXXS} align="center" className={flexStyle}>
            <InfoCircleOutlined />
            <span className={spanStyle}>
              Diagnose - {billingInfo.additionalText} {showPrice && <Price value={billingInfo.price} />}
            </span>
          </Flex>
        </Tooltip>
      );
    case BillingType.LG_DIAGNOSE:
      return (
        <Tooltip title={billingInfo.text}>
          <Flex gap={token.marginXXS} align="center" className={flexStyle}>
            <LgBadge /> <InfoCircleOutlined />
            <span className={spanStyle}>
              Diagnose - {billingInfo.additionalText} {showPrice && <Price value={billingInfo.price} />}
            </span>
          </Flex>
        </Tooltip>
      );
    case BillingType.LG_DOCTOR:
      return (
        <Flex gap={token.marginXXS} align="center" className={flexStyle}>
          <LgBadge />
          <span className={spanStyle}>Zuweiser {showPrice && <Price value={billingInfo.price} />}</span>
        </Flex>
      );
    case BillingType.DEFINE_LATER:
      return <span className={cx(spanStyle, errorText)}>{translateBillingType(billingInfo.billingType)}</span>;
    default:
      return (
        <span className={spanStyle}>
          {translateBillingType(billingInfo.billingType)} {showPrice && <Price value={billingInfo.price} />}
        </span>
      );
  }
};
